import { Nav } from "react-bootstrap";
import { useLocation, useNavigate, Routes, Route, Navigate } from "react-router-dom";
import Categories from "./settings/Categories";
import QuestionsAnswers from "./settings/QuestionsAnswers";
import { useGetEditSubCategories } from "../../hooks/useGetEditSubCategories";
import { useAuth } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { ROLE_SETTINGS_BACKKOFFICE_ADMIN } from "../../constants";

export default function Settings() {
	const navigate = useNavigate();
	const location = useLocation();
	const { userData } = useAuth();

	const hasAccess = userData?.user.userRoles?.includes(ROLE_SETTINGS_BACKKOFFICE_ADMIN);

	if (!hasAccess) {
		return <Navigate to="/backoffice" replace />;
	}

	const portalId = userData?.user.portals.find((f) => f != 0) ?? 0;

	const { data: editCategories, isLoading, refetch } = useGetEditSubCategories({ portalId });

	const activeTab = location.pathname.includes("/questions") ? "questions" : "categories";

	return (
		<div className="container mt-3">
			<Nav variant="tabs" activeKey={activeTab} onSelect={(key) => navigate(`/backoffice/settings/${key}`)}>
				<Nav.Item>
					<Nav.Link eventKey="categories">Categories</Nav.Link>
				</Nav.Item>
				<Nav.Item>
					<Nav.Link eventKey="questions">Questions &amp; Answers</Nav.Link>
				</Nav.Item>
			</Nav>

			<div className="mt-3">
				{isLoading ? (
					<Loader message="Loading settings..." />
				) : (
					<Routes>
						<Route path="/" element={<Navigate to="categories" replace />} />
						<Route path="categories" element={<Categories editCategories={editCategories ?? []} onRefresh={refetch} />} />
						<Route path="questions" element={<QuestionsAnswers editCategories={editCategories ?? []} />} />
					</Routes>
				)}
			</div>
		</div>
	);
}
